<template>
	<b-modal
		hide-footer
		ref="show-evidence"
		v-model="showModal"
		size="lg"
		:title="`Evidencias de estado: ${statusLabel}`"
	>
		<FilesRelated
			:model-id="transportServiceId"
			model-reference="transport-services"
			unable-delete
			:cols="3"
			:file-keys="[
				{label:'Evidencias', keyName: 'changeStatusEvidence[]'},
			]"
		/>
	</b-modal>
</template>

<script>
import FilesRelated from '@/components/helpers/FilesRelated'

export default {
	props: {
		status : {
			type: String,
			required: true,
		},
		transportServiceId : {
			type: Number,
			required: true,
		},
		show : {
			type: Boolean,
			required: true,
		},
	},
	components: {
		FilesRelated
	},
	data(){
		return {
		}
	},
	methods : {
	},
	computed : {
		statusLabel(){
			return this.$root.auxVars.transportServiceStatusOpts.find(status => status.value === this.status).text
		},
		showModal : {
			get(){
				return this.show
			},
			set(val){
				this.$emit('update:show',val)
			}
		}
	}
}
</script>
